import { ApiTimeslot } from "types/api";
import { Timeslot } from "types/entities";

export const serializeTimeslot = (timeslot: ApiTimeslot): Timeslot => ({
  minutesEnd: timeslot.minutes_end,
  minutesStart: timeslot.minutes_start,
});
